{
  "primary": {
    "primary-50": "rgb(255, 246, 253)",
    "primary-100": "rgb(255, 238, 249)",
    "primary-150": "rgb(254, 230, 246)",
    "primary-200": "rgb(253, 222, 242)",
    "primary-250": "rgb(251, 212, 239)",
    "primary-300": "rgb(249, 201, 235)",
    "primary-350": "rgb(247, 191, 233)",
    "primary-400": "rgb(244, 181, 230)",
    "primary-450": "rgb(239, 150, 218)",
    "primary-500": "rgb(233, 117, 204)",
    "primary-550": "rgb(225, 80, 190)",
    "primary-600": "rgb(217, 18, 174)",
    "primary-650": "rgb(187, 12, 148)",
    "primary-700": "rgb(157, 6, 123)",
    "primary-750": "rgb(129, 2, 100)",
    "primary-800": "rgb(101, 0, 77)",
    "primary-850": "rgb(77, 0, 58)",
    "primary-900": "rgb(55, 0, 40)",
    "primary-950": "rgb(34, 0, 23)"
  },
  "accent": {
    "accent-50": "rgb(255, 250, 246)",
    "accent-100": "rgb(255, 246, 238)",
    "accent-150": "rgb(254, 241, 231)",
    "accent-200": "rgb(253, 237, 223)",
    "accent-250": "rgb(254, 229, 206)",
    "accent-300": "rgb(255, 221, 189)",
    "accent-350": "rgb(255, 214, 171)",
    "accent-400": "rgb(255, 206, 153)",
    "accent-450": "rgb(253, 182, 120)",
    "accent-500": "rgb(251, 157, 88)",
    "accent-550": "rgb(247, 129, 57)",
    "accent-600": "rgb(243, 99, 27)",
    "accent-650": "rgb(219, 81, 21)",
    "accent-700": "rgb(195, 63, 14)",
    "accent-750": "rgb(171, 46, 6)",
    "accent-800": "rgb(148, 27, 0)",
    "accent-850": "rgb(115, 15, 0)",
    "accent-900": "rgb(83, 4, 0)",
    "accent-950": "rgb(53, 0, 0)"
  },
  "grey": {
    "grey-50": "rgb(250, 250, 250)",
    "grey-100": "rgb(245, 245, 245)",
    "grey-150": "rgb(240, 240, 240)",
    "grey-200": "rgb(235, 235, 235)",
    "grey-250": "rgb(227, 229, 230)",
    "grey-300": "rgb(220, 223, 224)",
    "grey-350": "rgb(212, 217, 219)",
    "grey-400": "rgb(205, 211, 214)",
    "grey-450": "rgb(170, 176, 180)",
    "grey-500": "rgb(136, 143, 146)",
    "grey-550": "rgb(104, 111, 114)",
    "grey-600": "rgb(73, 80, 84)",
    "grey-650": "rgb(63, 69, 73)",
    "grey-700": "rgb(53, 59, 63)",
    "grey-750": "rgb(43, 49, 53)",
    "grey-800": "rgb(34, 39, 43)",
    "grey-850": "rgb(24, 28, 31)",
    "grey-900": "rgb(14, 17, 19)",
    "grey-950": "rgb(5, 7, 9)"
  }
}
